module.exports = __webpack_public_path__ + "static/img/31.f5a74d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/flag_icons/31.png
// module id = +z/B
// module chunks = 1